// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import './core/polyfill';
import '/root/workspace/packaging-mall-web_oFdC/src/global.less';
import '/root/workspace/packaging-mall-web_oFdC/src/global.ts';
import 'antd/dist/antd.less';
import { renderClient } from '/root/workspace/packaging-mall-web_oFdC/node_modules/@umijs/renderer-react';
import { getRoutes } from './core/route';
import { createPluginManager } from './core/plugin';
import { createHistory } from './core/history';
import { ApplyPluginsType } from 'umi';
import '/root/workspace/packaging-mall-web_oFdC/src/overrides.less';
import '/root/workspace/packaging-mall-web_oFdC/src/.umi-production/plugin-tailwindcss/tailwind.css';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

const publicPath = "https://file.meilisci.com/static/packaging-mall-web/";
const runtimePublicPath = false;

async function render() {
  const pluginManager = createPluginManager();
  const { routes, routeComponents } = await getRoutes(pluginManager);

  // allow user to extend routes
  await pluginManager.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: {
      routes,
      routeComponents,
    },
  });

  const contextOpts = pluginManager.applyPlugins({
    key: 'modifyContextOpts',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });

  const basename = contextOpts.basename || '/';
  const historyType = contextOpts.historyType || 'browser';

  const history = createHistory({
    type: historyType,
    basename,
    ...contextOpts.historyOpts,
  });

  return (pluginManager.applyPlugins({
    key: 'render',
    type: ApplyPluginsType.compose,
    initialValue() {
      const context = {
        routes,
        routeComponents,
        pluginManager,
        rootElement: contextOpts.rootElement || document.getElementById('root'),
        publicPath,
        runtimePublicPath,
        history,
        historyType,
        basename,
        callback: contextOpts.callback,
      };
      const modifiedContext = pluginManager.applyPlugins({
        key: 'modifyClientRenderOpts',
        type: ApplyPluginsType.modify,
        initialValue: context,
      });
      return renderClient(modifiedContext);
    },
  }))();
}


      Sentry.init({
        dsn: "https://2ee2310e6ffb461aa25f9cd5d34f03cb@o1411873.ingest.sentry.io/4504596864892928",
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: 1,
        environment: "prod",
        ...{"release":"prod@1.0.0"}
      });
    
render();

window.g_umi = {
  version: '4.0.40',
};
